import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiServiceExtension } from 'src/app/core/extension/apiServiceExtension';
import { AppConfig } from 'src/app/core/_config/app.config';
import { CustomResponse } from 'src/app/interfaces/CustomResponse';

@Injectable({
    providedIn: 'root',
})
export class MappingCurrentAccountBilletService extends ApiServiceExtension {
    constructor(protected config: AppConfig, public http: HttpClient) {
        super(config, http);
    }

    public GetByContractId(contractId: string): Observable<CustomResponse<any>> {
        let url = `${this.API_URL}MappingCurrentAccountBillet/GetByContractId`;
        return this.http.get<CustomResponse<any>>(url, {
            params: {
                contractId: contractId,
            },
        });
    }

    public Generate(contractId: string, newMapping: boolean): Observable<any> {
        return this.http.post<any>(
            `${this.API_URL}MappingCurrentAccountBillet/ReMapping`,
            { contractId: contractId, newMapping: newMapping },
            { headers: this.headers },
        );
    }

    public GenerateList(contractIds: string[], newMapping: boolean): Observable<any> {
        return this.http.post<any>(
            `${this.API_URL}MappingCurrentAccountBillet/ReMappingList`,
            { contractIds: contractIds, newMapping: newMapping },
            { headers: this.headers },
        );
    }

    public GetContractsByParam(
        newMapping: boolean,
        levelId: string,
        periodId: string,
        MappingFilterEnum: number,
        entityId: string,
        legalEntityId: string,
        subaccount: number,
    ): Observable<any> {
        let param = {
            newMapping: newMapping.toString(),
            levelId,
            periodId,
            MappingFilterEnum: MappingFilterEnum.toString(),
            subaccount: subaccount.toString(),
            entityId: entityId,
            legalEntityId: legalEntityId,
        };

        //delete property null
        Object.keys(param).forEach((key) => {
            if (param[key] === null) {
                delete param[key];
            }
        });

        return this.http.get(`${this.API_URL}MappingCurrentAccountBillet/GetContractsByParam`, {
            headers: this.headers,
            params: param,
        });
    }
}
